import axios from 'axios';
import { EventDTO, SchoolYear } from '../types';

/**
 * Loads the events of the school year with the given name.
 * Resolves to null when there is no school year with that name.
 * `apiBase` is '/api' for the authenticated app and `/api/public/${secret}` for the public page.
 */
export async function fetchEventsForSchoolYear(schoolYearName: string, apiBase: string = '/api'): Promise<EventDTO[] | null> {
    const { data: schoolYears } = await axios.get<SchoolYear[]>(`${apiBase}/school-years`);
    const schoolYear = schoolYears.find(sy => sy.name === schoolYearName);
    if (!schoolYear) {
        return null;
    }
    const { data } = await axios.get<EventDTO[]>(`${apiBase}/events/school-year/${schoolYear.id}`);
    return data;
}
